<template>
  <v-container class="margen_paginas pt-7">
    <v-card max-width="240px" style="background: rgba(180, 180, 180, 0.85);">
      <div class="text-h5 mb-4 d-flex align-center pa-1">
        <v-icon large class="mr-1">mdi-home</v-icon>
        {{$t ('Inicio')}}
      </div>
    </v-card>

    <template v-if="estadisticasEmpresaInquilina">
      <TarjetaResumen icono="mdi-card-account-details-outline" color="#40AF90" :valor="estadisticasEmpresaInquilina.numero_total_pases">{{ $t ('Total de pases') }}</TarjetaResumen>
      <TarjetaResumen v-if="estadisticasEmpresaInquilina.empresa_inquilina" icono="mdi-chart-line" color="#4090AF" :valor="estadisticasEmpresaInquilina.total_plazas_ocupadas + ' / ' + estadisticasEmpresaInquilina.empresa_inquilina.platot">{{ $t ('Total de plazas ocupadas') }}</TarjetaResumen>
      <TarjetaResumen v-else icono="mdi-chart-line" color="#4090AF" :valor="estadisticasEmpresaInquilina.total_plazas_ocupadas">{{ $t ('Total de plazas ocupadas') }}</TarjetaResumen>
      <TarjetaResumen v-if="$parametros_configuracion.modres" icono="mdi-calendar-check" color="#AF4090" :valor="estadisticasEmpresaInquilina.total_reservas_usadas_hoy + ' / ' + estadisticasEmpresaInquilina.total_reservas_hoy">{{ $t ('Reservas utilizadas (hoy)') }}</TarjetaResumen>
      <TarjetaResumen icono="mdi-swap-horizontal-bold" color="#9575CD" :valor="estadisticasEmpresaInquilina.numero_accesos_hoy">{{ $t ('Accesos (hoy)') }}</TarjetaResumen>
      <TarjetaResumen icono="mdi-alert" color="#FF8A65" :valor="estadisticasEmpresaInquilina.numero_incidencias_hoy">{{ $t ('Incidencias (hoy)') }} </TarjetaResumen>
      <!-- {{estadisticasEmpresaInquilina}} -->
    </template>

    <div v-if="$parametros_configuracion ['modempinq']" style="margin-top: 10px; max-width: 750px">
      <TablaDatosAPI
        ref="tablaInformePasesPresentes"
        :key="claveTablaResumenOcupacion"
        :titulo="$t ('Resumen de ocupación')"
        icono="mdi-chart-pie"
        :tabla="vistaInformePasesPresentes"
        :campos="['*']"
        :parametros="mostrarConteosA0 ? { conteoMinimo: { valor: 0, descripcion: 'Incluir conteos a 0' } } : { conteoMinimo: { valor: 1, descripcion: '' } }"
        width="500px"
        dense
        modo-memoria
        :segundos-auto-refresco="7">

        <template v-slot:debajo-titulo>
          <v-select :items="informesPasesPresentes" filled hide-details dense v-model="vistaInformePasesPresentes" @change="actualizarDatosTabla" background-color="#d7ccd7"></v-select>
          <div class="pl-3 pt-1 pb-1" style="background: #d7d7cc"><v-switch class="ma-0" hide-details inset :label="$t ('Mostrar contadores a 0')" dense v-model="mostrarConteosA0" @change="actualizarDatosTabla"></v-switch></div>
        </template>

        <template v-slot:[`item.id_empinq__VT`]="{ item }">
          {{ item.id_empinq__VT }}
          <span v-if="item.platot > 0" style="font-size: 10px"> / {{ item.platot }}</span>
        </template>

        <template v-slot:[`item.numpaspre`]="{ item }">
          <span style="font-weight: 500">{{ item.numpaspre }}</span>
          <span v-if="item.maxplazon > 0"> / {{ item.maxplazon }}</span>
        </template>
      </TablaDatosAPI>
    </div>

  </v-container>
</template>

<script>
import TarjetaResumen from '@/components/TarjetaResumen.vue'
import api from "@/api"
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TarjetaResumen,
                TablaDatosAPI,
                },
  data: () => ({
    informesPasesPresentes: [
      { text: "Por Tipos de pase", value: "v_infpaspre_tippas" },
      { text: "Por Zonas", value: "v_infpaspre_zon" },
      { text: "Por Tipos de pases y Zonas", value: "v_infpaspre_tippaszon" }
    ],

    claveTablaResumenOcupacion: 1,
    mostrarConteosA0: false,
    vistaInformePasesPresentes: "v_infpaspre_zon",

    estadisticasEmpresaInquilina: null // cards!
  }),
  methods: {
    actualizarDatosTabla() {
      this.$nextTick (() => { this.claveTablaResumenOcupacion++ });
    },

  },
  mounted(){
    api.obtenerEstadisticasEmpresaInquilina ()
      .then ((respuesta) => {
        this.estadisticasEmpresaInquilina = respuesta.data;
      });
  }
}
</script>

<style>
</style>